import Vue from 'vue'      
import Router from 'vue-router'   

Vue.use(Router);

const routes = [
  {
    path: '/',
    component: () => import('@/views/portal'),
    name: 'portal',
    meta: {
      title: '编程直播'
    }
  },
  {
    path: '/article/:id',
    component: () => import('@/views/portal'),
    name: 'portalArticle',
    meta: {
      title: '编程直播内容'
    }
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/main'),
    redirect:'/index/home',
    meta:{
      title:"直播首页"
    },
    children: [
      {
        path: 'home',
        component: () => import('@/views/home'),
        name: 'home',
        meta: {
          title: '首页',
          isTab: true
        }
      },
      {
        path: 'collect',
        component: () => import('@/views/collect'),
        name: 'collect',
        meta: {
          title: 'collect',
        }
      },
      {
        path: 'order',
        component: () => import('@/views/order'),
        name: 'order',
        meta: {
          title: '我的订单',
        }
      }
    ]
  },
  {
    path: '/index/live',
    component: () => import('@/views/live'),
    name: 'live',
    meta: {
      title: '直播间',
    }
  },
  {
    path: '/home',
    redirect: '/'
  },
  {
    path: '/live',
    redirect: to => ({ path: '/index/live', query: to.query })
  }
]

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



var router =  new Router({
    routes
})
export default router;

